<template>
  <div>
    <SubTitle text="Administrador de pedidos">

      <el-dropdown trigger="click" class="right" @command="openAdd">
        <el-button size="small" class="default">
          CARGAR POR<i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="SUBORDEN" icon="fas fa-box">SOC</el-dropdown-item>
          <el-dropdown-item command="LPN" icon="fas fa-barcode">LPN</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </SubTitle>
    <div class="card-section">
      <div class="card-navbar">
        <ActionSimple name="no encontradas" icon="el-icon-document-copy" @action="copyNotFound"
          :disabled="list | existNotFound" />
        <ActionMultiple name="eliminar" icon="el-icon-delete" :options="optionsToDelete" @action="deleteSocs"
          :disabled="disabledMassiveOptions" />
        <ActionSimple name="limpiar filtros" icon="fas fa-filter" @action="clearFilter" :disabled="filterEnable < 1" />
        <Indicator :indicator="list | indicator" class="right" />
      </div>
      <p v-if="list.length < 1" class="msg-not-sector">NINGUNA SOC/LPN INGRESADA</p>
      <el-table v-else :data="suborderPaged" ref="tableSuborder" @selection-change="handleSelectionChange"
        @filter-change="applyFilter" row-class-name="row-medium">
        <el-table-column type="selection" />
        <el-table-column prop="sectors" label="Información">
          <template slot-scope="scope">
            <span v-if="notFound(scope.row)" class="status-soc">
              <i class="fas fa-question" />no encontrado
            </span>
            <span v-else-if="notPlannable(scope.row)" class="status-soc">
              <i class="fas fa-times" />fue {{ scope.row.last_state_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column min-width="130" sortable label="SOC" prop="suborder" />
        <el-table-column sortable label="LPN" prop="lpn"/>
        <el-table-column min-width="130" sortable label="TIPO" prop="document_type_name"/>
        <el-table-column sortable label="Localidad" prop="locality" column-key="locality" :filters="filterLocalityData">
        </el-table-column>
        <el-table-column sortable label="Fecha" prop="requested_at" :formatter="formatDate" column-key="requested"
          align="center" :filters="filterRequestedAtData">
        </el-table-column>
        <el-table-column align="center" label="Eliminar" v-slot="scope">
          <a class="el-icon-delete delete-soc-icon" @click="deleteSuborder(scope.row.suborder)" />
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination v-if="this.suborders.length > 0" layout="sizes, total, prev, pager, next" :page-size="this.pageSize"
        :page-sizes="this.pageSizes" :pager-count="5" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" :total="this.suborders.length">
      </el-pagination>
    </div>
    <SuborderAdd ref="dialogAdd" v-model="list" />

    <LpnAdd ref="dialogAddLpn"
      v-model="list"
    />
  </div>
</template>

<script>
import moment from 'moment';
import SuborderAdd from './Add.vue';
import LpnAdd from '../../planningv4/suborder/Lpn.vue';
import Indicator from './Indicator.vue';
import SubTitle from '../../base/SubTitle.vue';
import ActionSimple from '../../planningv4/suborder/action/Simple.vue';
import ActionMultiple from '../../planningv4/suborder/action/Multiple.vue';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  name: 'SuborderList',
  components: {
    SubTitle,
    Indicator,
    SuborderAdd,
    ActionSimple,
    ActionMultiple,
    LpnAdd,
  },
  data() {
    return {
      checked: [],
      pageSize: 10,
      pageSizes: [10, 20, 30, 40, 50, 100],
      currentPage: 0,
      totalChecked: 0,
      list: this.value,
      filterDateAt: [],
      filterLocality: [],
      countPlannable: 0,
    };
  },
  watch: {
    checked() {
      this.totalChecked = this.checked.length;
    },
    list: {
      handler(socs) {
        if (socs.length === 0) this.currentPage = 0;
        const finalCount = socs.reduce((acc, el) => {
          if (el.current_do === -1) acc.counts.notFound += 1;
          else if (el.last_state === 5) acc.counts.finished += 1;
          else if (el.last_state === 6) acc.counts.canceled += 1;
          else {
            acc.counts.plannable += 1;
            acc.socs.push(el.suborder);
          }
          return acc;
        }, {
          socs: [],
          counts: {
            plannable: 0, notFound: 0, finished: 0, canceled: 0,
          },
        });
        this.countPlannable = finalCount.socs.length;
        this.$emit('suborders', finalCount);
      },
      deep: true,
    },
  },
  filters: {
    existNotFound(data) {
      return data.filter(s => s.current_do === -1).length < 1;
    },
    indicator(list) {
      return {
        total: list.length,
        plannable: list
          .filter(s => s.verified && s.current_do !== -1 && ![5, 6].includes(s.last_state)).length,
      };
    },
  },
  methods: {
    openAdd(mode) {
      switch (mode) {
        case 'LPN':
          this.$refs.dialogAddLpn.open();
          break;
        default:
          this.$refs.dialogAdd.open();
          break;
      }
    },
    async copyNotFound() {
      const socs = this.list.filter(s => this.notFound(s)).map(s => s.suborder);
      const base = `Se han copiado ${socs.length}`;
      const countText = socs.length > 1 ? `${base} elementos` : `${base} elemento`;
      await navigator.clipboard.writeText(socs.join('\r\n')).then(
        this.$notify.success({ title: countText }),
      );
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1;
    },
    handleSizeChange(val) {
      this.currentPage = 0;
      this.pageSize = val;
    },
    applyFilter(filters) {
      this.currentPage = 0;
      if (filters.locality) this.filterLocality = filters.locality;
      if (filters.requested) this.filterDateAt = filters.requested;
    },
    formatDate(row) {
      const date = moment.utc(row.requested_at).format('DD/MM/YY');
      return ['01/01/01', '01/01/70'].includes(date) ? '' : date;
    },
    notFound(soc) {
      return soc.current_do === -1;
    },
    notPlannable(soc) {
      return [5, 6].includes(soc.last_state);
    },
    handleSelectionChange(val) {
      this.checked = val.map(s => s.suborder);
    },
    deleteSocs(option) {
      if (option === 0) {
        this.deleteAllSelected();
      } else if (option === 1) {
        this.deleteAllPaginated();
      }
    },
    deleteAllPaginated() {
      this.$confirm('¿Está seguro que desea eliminar las socs paginadas?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list
          .filter(s => this.suborders
            .findIndex(val => val.suborder === s.suborder) === -1);
        this.checked = [];
        this.clearFilter();
        this.verifyPaged();
        this.$notify.success({ title: 'Subordenes eliminadas con éxito' });
      }).catch(() => { });
    },
    deleteAllSelected() {
      this.$confirm('¿Está seguro que desea eliminar las socs seleccionadas?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list
          .filter(s => this.checked
            .findIndex(val => val === s.suborder) === -1);
        this.checked = [];
        this.clearFilter();
        this.verifyPaged();
        this.$notify.success({ title: 'Subordenes eliminadas con éxito' });
      }).catch(() => { });
    },
    deleteSuborder(soc) {
      this.$confirm('¿Está seguro que desea eliminar la soc?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list.filter(s => s.suborder !== soc);
        if (this.list.length === 0) this.checked = [];
        this.verifyPaged();
        this.$notify.success({ title: 'Suborden eliminada con éxito' });
      }).catch(() => { });
    },
    verifyPaged() {
      if (this.suborderPaged.length === 0
        && this.currentPage > 0) this.currentPage = this.currentPage - 1;
    },
    clearFilter() {
      this.filterDateAt = [];
      this.filterLocality = [];
      if (this.$refs.tableSuborder) this.$refs.tableSuborder.clearFilter();
    },
  },
  computed: {
    optionsToDelete() {
      return [{
        name: `seleccionadas (${this.totalChecked})`,
        disabled: this.totalChecked < 1,
      }, {
        name: `paginadas (${this.suborders.length})`,
        disabled: this.suborders.length < 1,
      }];
    },
    disabledMassiveOptions() {
      return this.totalChecked < 1 && this.suborders.length < 1;
    },
    filterEnable() {
      return this.filterDateAt.length > 0
        || this.filterLocality.length > 0;
    },
    suborderPaged() {
      return this.suborders
        .slice(this.currentPage * this.pageSize, (this.currentPage + 1) * this.pageSize);
    },
    suborders() {
      // TODO: Mejorar implementación, muy artesanal
      return this.list.filter((s) => {
        const filter = [];
        if (this.filterDateAt.length > 0) filter.push(this.filterDateAt.includes(s.requested_at));
        if (this.filterLocality.length > 0) filter.push(this.filterLocality.includes(s.locality));
        return filter.reduce((acc, el) => acc && el, true);
      });
    },
    filterLocalityData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const locality = pt.locality === '' ? '(Vacío)' : pt.locality;
          return ({ text: locality, value: pt.locality });
        })
        .filter((pt, i, acum) => acum.findIndex(t => t.text === pt.text) === i)
        .sort((a, b) => (b.text > a.text ? -1 : 1));
    },
    filterRequestedAtData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const date = moment.utc(pt.requested_at).format('DD/MM/YY');
          const requestedAt = ['01/01/01', '01/01/70'].includes(date) ? '(Vacío)' : date;
          return ({ text: requestedAt, value: pt.requested_at });
        })
        .filter((pt, i, acum) => acum.findIndex(t => t.text === pt.text) === i)
        .sort((a, b) => (b.value > a.value ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
.left {
  float: left;
}

.right {
  float: right;
}

.card-section {
  border-radius: 3px;
  border: 1px solid #eaeaea;

  .msg-not-sector {
    text-align: center;
    font-weight: 700;
    margin: 20px 12px;
    color: #888;
  }

  .card-navbar {
    color: #656565;
    padding: 0 2px;
    font-size: 13px;
    text-align: left;
    margin-bottom: 10px;
    border-bottom: 1px solid #eaeaea;

    .right {
      float: right;
    }
  }
}

.action-socs-btn,
.action-sub-btn {
  border: none;

  i {
    font-weight: 900;
  }

  span {
    margin-left: 7px;
  }
}

.action-socs-btn {
  padding: 6px 12px;
  margin: 0 0 5px 10px;
}

.action-sub-btn {
  padding: 0;
  background-color: white !important;
  margin: 10px 12px 0 12px;
  text-decoration: underline;
  color: #AAD500;
}

#disable-link-delete,
#disable-link-clean {
  background-color: white !important;
}

.delete-soc-icon {
  cursor: pointer;
  font-size: 14px;
  margin: 7px 0;
}

.delete-soc-icon:hover {
  color: #ff8585;
}

.status-soc {
  width: 15px;
  display: inline-block;

  .fa-times {
    margin-right: 8px;
  }

  .fa-question {
    margin-right: 7px;
  }

  .fa-times,
  .fa-question {
    color: #ff8585;
  }

  i {
    vertical-align: middle;
  }
}
</style>
